import { WarningLevel } from "@/lib/warning-level";
import { WarningColor } from "@/features/shared/hooks/useHighestWarning";

export function warningLevelToWarningColor(level: WarningLevel): WarningColor {
  switch (level) {
    case WarningLevel.Red:
      return WarningColor.RED;
    case WarningLevel.Orange:
      return WarningColor.ORANGE;
    case WarningLevel.Yellow:
      return WarningColor.YELLOW;
    default:
      return WarningColor.GREEN;
  }
}

/**
 * Colour for a warning-page toolbar button, or undefined to hide it. Buttons only show
 * for an actual warning (yellow or higher); green, unknown and still loading all hide.
 */
export function toolbarWarningButtonColor(
  level: WarningLevel | undefined,
): WarningColor | undefined {
  if (level === undefined) return undefined;
  const color = warningLevelToWarningColor(level);
  return color === WarningColor.GREEN ? undefined : color;
}
